import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addEarnPlan } from "../../../Features/EarnCampaign/earnSlice";

const EarnModal = ({ show, setShowModal, data }) => {
  const [amount, setAmount] = useState(0);
  const [duration, setDuration] = useState(0);
  const [autoRenew, setAutoRenew] = useState(false);
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.earn);

  useEffect(() => {
    setDuration(data?.DurationOptions?.split(",")[0]);
  }, [data]);
  const handleCampaignJoin = () => {
    if (!amount || !duration) {
      toast.error("All fields required!");
      return;
    }
    if (amount <= 0 || amount < data?.MinAmount) {
      toast.error(
        "Minimum amount should be " +
          data?.MinAmount +
          " " +
          data?.PrincipalCurrency,
      );
      return;
    }

    if (amount > data?.MaxAmount) {
      toast.error(
        "Maximum amount should be " +
          data?.MaxAmount +
          " " +
          data?.PrincipalCurrency,
      );
      return;
    }

    dispatch(
      addEarnPlan({ campaignid: data?.ID, duration, amount, autoRenew }),
    ).then((d) => {
      const status = d?.payload?.status;
      const message = d?.payload?.message;
      if (status === 0) {
        toast.success(message);
        setShowModal(false);
        setAmount(0);
        return;
      } else {
        toast.error(message);
        return;
      }
    });
  };

  const handleCloseModal = () => {
    setAmount(0);
    setShowModal(false);
  };

  return (
    <Modal show={show} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Join: {data?.Title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="campaign-modal">
          <div className="borderLine"></div>

          <div className="body-content">
            <p className="text-left">{`Enter the ${data?.PrincipalCurrency} amount you want to lock:`}</p>
            <div className="row px-3 durationAmount">
              <input
                type="number"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>

            <p className="text-left mt-3">{"Lock Duration:"}</p>
            <div className="row px-3 DurationOption">
              {data?.DurationOptions?.split(",").map((d) => (
                <span
                  className={`col-3 ${duration === d && "active"}`}
                  onClick={() => setDuration(d)}
                >
                  {d} days
                </span>
              ))}
            </div>

            <p className="text-left mt-3">{"Auto Renew:"}</p>
            <div className="row px-3 DurationOption">
              <span
                className={`col-3 ${autoRenew && "active"}`}
                onClick={() => setAutoRenew(true)}
              >
                Yes
              </span>
              <span
                className={`col-3 ${!autoRenew && "active"}`}
                onClick={() => setAutoRenew(false)}
              >
                No
              </span>
            </div>
            <button
              className="joinBtn mt-4"
              onClick={handleCampaignJoin}
              disabled={isLoading}
            >
              {isLoading ? "Joining..." : "Join Campaign"}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EarnModal;
